import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import React from 'react';

const styles = () => ({
  dialogContent: {
    height: 500,
  },
  dialogBorder: {
    height: '20px',
  },
  title: {
    marginBottom: '.5em',
  },
});

// Modal for maintainers to see requests
const TermRequestModal = (props) => {
  const { requests, open, handleClose, deleteRequest, terms, classes } = props;
  return (
    <div>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <div className={classes.dialogBorder} />
        <DialogTitle>
          <Typography variant="h4" className={classes.textCaps}>
            Term Requests
          </Typography>
        </DialogTitle>
        <div className={classes.dialogBody}>
          <DialogContent className={classes.dialogContent}>
            {requests ? (
              Object.keys(requests).map((key, index) =>
                terms.includes(requests[key].term) ? (
                  <div />
                ) : (
                  <div style={{ marginTop: '1em' }}>
                    <Typography>
                      <u>Request {index + 1}</u>
                      <Button
                        style={{ marginLeft: '1em' }}
                        onClick={() => deleteRequest(key)}
                      >
                        DELETE
                      </Button>
                    </Typography>
                    <Typography>Term: {requests[key].term}</Typography>
                    {requests[key].parent ? (
                      <Typography>Parent: {requests[key].parent}</Typography>
                    ) : (
                      <div />
                    )}
                    {requests[key].details ? (
                      <Typography>Details: {requests[key].details}</Typography>
                    ) : (
                      <div />
                    )}
                    {requests[key].email ? (
                      <Typography>Submitter: {requests[key].email}</Typography>
                    ) : (
                      <div />
                    )}
                  </div>
                )
              )
            ) : (
              <Typography>
                <i>No requests currently</i>
              </Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} variant="outlined">
              Close
            </Button>
          </DialogActions>
        </div>
        <div className={classes.dialogBorder} />
      </Dialog>
    </div>
  );
};

// Modal for maintainers to see requests
export default withStyles(styles)(TermRequestModal);
